module.exports = __webpack_public_path__ + "static/media/IMG_1619.a0f8914a.JPG";